import React from 'react'
import { Text, Heading } from '../textElements'

import { StyledButton, Inner } from './styles'

const AnswerButton = ({ reverse, heading, text, onClick }) => (
  <StyledButton onClick={onClick}>
    <Inner>
      {reverse && <Text margin="0">{text}</Text>}
      <Heading as="h2" margin="0">
        {heading}
      </Heading>
      {!reverse && <Text margin="0">{text}</Text>}
    </Inner>
  </StyledButton>
)

export default AnswerButton
